import { styled } from '@mui/material';
import Stack, { type StackProps } from '@mui/material/Stack';

export const FullHeightPage = styled(Stack)<StackProps>(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: (theme.vars || theme).palette.background.paper,
}));
